import Button from '@taglivros/oef_componentes/build/components/button'
import Card from '@taglivros/oef_componentes/build/components/card'
import InlineLoader from '../../../../components/InlineLoader/InlineLoader'

import CartaoCredito from '../../../../components/CartaoCredito/CartaoCredito'
import React from 'react'
import { bool, func, object } from 'prop-types'
import styled from 'styled-components'
import { TEXTO_BOTOES, MENSAGEM_VIGENTE } from './constantsCardCartao.js'

const ButtonWrapper = styled.div`
  max-width: 130px;
  overflow: hidden;
  position: absolute;
  right: 0px;
  top: 5px;

  button {
    font-size: 16px;
  }
`

const BotaoUsarVigente = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 16px;
`

const Titulo = styled.h2`
  margin: 0 0 18px;
`

const WrapperLoding = styled.div`
  height: 100%;
  width: 100%;
  > div {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`

const CardCartao = ( { ativo, cartao, isVigente, botaoExcluir, onExcluir, usarComoVigente, loading, showExcluir } ) => {
  return (
    <Card
      ativo={ ativo }
      className="card"
      largura="100%"
    >
      {loading ? (
        <WrapperLoding>
          <InlineLoader />
        </WrapperLoding>
      ) : (
        <>
          {isVigente ? <Titulo>{MENSAGEM_VIGENTE}</Titulo> : null}

          <CartaoCredito
            cartao={ cartao }
            desativado={ !isVigente }
            hover={ false }
            margin={ !isVigente ? '30px 0 0' : null }
          />

          {
            botaoExcluir && showExcluir ?
              <ButtonWrapper>
                <Button
                  invertido
                  noBackground
                  onClick={ () => onExcluir() }
                  testId="excluir"
                >
                  {TEXTO_BOTOES.EXCLUIR}
                </Button>
              </ButtonWrapper> : null
          }

          {
            !isVigente && usarComoVigente && cartao.idGateway && showExcluir ?
              <BotaoUsarVigente>
                <Button
                  onClick={ () => usarComoVigente() }
                  tema={ Button.BOTAO_CURADORIA }
                  testId="usar-vigente"
                >
                  {TEXTO_BOTOES.USAR_COMO_VIGENTE}
                </Button>
              </BotaoUsarVigente> : null
          }
        </>
      )}
    </Card>
  )
}

CardCartao.propTypes = {
  'ativo': bool,
  'botaoExcluir': bool,
  'cartao': object.isRequired,
  'isVigente': bool,
  'onExcluir': func,
  'usarComoVigente': func,
  'loading': bool.isRequired,
  'showExcluir': bool.isRequired,
}

CardCartao.defaultProps = {
  'ativo': false,
  'botaoExcluir': true,
  'isVigente': false,
  'onExcluir': () => {},
  'usarComoVigente': () => {}
}

export default CardCartao
